module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10212.c17b8571.jpg";